import React from 'react'
import './style/index.scss';
import { CategoryAnalysisProvider } from './context/CategoryAnalysisContext';

import Header from './Header';
import MainAnalysisView from './MainAnalysisView';

const CategoryAnalysisContainer = () => {
  return (
    <CategoryAnalysisProvider>
        <div className="category-analysis">
          <Header />
          <MainAnalysisView />
        </div>
    </CategoryAnalysisProvider>
  )
}

export default CategoryAnalysisContainer